"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingTypes = exports.workflowTypes = exports.debtorUpdateTypes = exports.visitTypes = exports.interactionTypes = exports.economyTypes = exports.BlameLogRefType = exports.BlameLogType = void 0;
var BlameLogType;
(function (BlameLogType) {
    BlameLogType["CaseVoucherDelete"] = "VOUCHER-DELETE";
    BlameLogType["UnknownCaseVoucherMapped"] = "UNKNOWN-CASE-VOUCHER-MAPPED";
    BlameLogType["CaseVoucherPatch"] = "CASE-VOUCHER-PATCH";
    BlameLogType["VisitedBy"] = "VISITED-BY";
    BlameLogType["CaseVisit"] = "CASE-VISIT";
    BlameLogType["UserOnCustomerVisit"] = "USER-ON-CUSTOMER-VISIT";
    BlameLogType["DebtorUpdateName"] = "DEBTOR-UPDATE-NAME";
    BlameLogType["DebtorUpdatePhone"] = "DEBTOR-UPDATE-PHONE";
    BlameLogType["DebtorUpdateAddress"] = "DEBTOR-UPDATE-ADDRESS";
    BlameLogType["DebtorUpdateEmail"] = "DEBTOR-UPDATE-EMAIL";
    BlameLogType["DebtorUpdateCourt"] = "DEBTOR-UPDATE-COURT";
    BlameLogType["DebtorUpdateCarRegistrationNumber"] = "CAR-REGISTRATION-NUMBER";
    BlameLogType["DebtorUpdateBirthdate"] = "DEBTOR-UPDATE-BIRTHDATE";
    BlameLogType["DebtorUpdateCVR"] = "DEBTOR-UPDATE-CVR";
    BlameLogType["DebtorUpdateCPR"] = "DEBTOR-UPDATE-CPR";
    BlameLogType["CreditorVisit"] = "CREDITOR-VISIT";
    BlameLogType["CreditorSettingsUpdate"] = "CREDITOR-SETTINGS-UPDATE";
    BlameLogType["CaseVoucherIrrecoverable"] = "VOUCHER-IRRECOVERABLE";
    BlameLogType["CaseVoucherExpired"] = "VOUCHER-EXPIRED";
    BlameLogType["InteractionDelete"] = "INTERACTION-DELETE";
    BlameLogType["InteractionRollback"] = "INTERACTION-ROLLBACK";
    BlameLogType["InteractionHideFromClient"] = "INTERACTION-HIDE-FROM-CLIENT";
    BlameLogType["DebtorWebLoginEId"] = "DEBTOR-WEB-LOGIN-E-ID";
    BlameLogType["WorkflowRollback"] = "WORKFLOW-ROLLBACK";
    BlameLogType["RKIAuto"] = "RKI-AUTO";
    BlameLogType["RKIOpen"] = "RKI-OPEN";
    BlameLogType["RKIIgnoreOppositions"] = "RKI-IGNORE-OPPOSITIONS";
    BlameLogType["RKIDeleteOnCaseEnd"] = "RKI-DELETE-ON-CASE-END";
    BlameLogType["AKSConfiguration"] = "AKS-CONFIGURATION";
    BlameLogType["AKSClientID"] = "AKS-CLIENT-ID";
    BlameLogType["RKIOveride"] = "RKI-OVERRIDE";
    BlameLogType["AKSActivated"] = "AKS-ACTIVATED";
    BlameLogType["PriceList"] = "PRICE-LIST";
    BlameLogType["UserPasswordUpdate"] = "USER-PASSWORD-UPDATE";
    BlameLogType["TriggerShortcut"] = "TRIGGER-SHORTCUT";
    BlameLogType["WorkflowChange"] = "WORKFLOW-CHANGE";
    BlameLogType["DeleteUpdate"] = "DELETE-UPDATE";
    BlameLogType["ConnectorBillingUpdate"] = "CONNECTOR-BILLING-UPDATE";
})(BlameLogType || (exports.BlameLogType = BlameLogType = {}));
var BlameLogRefType;
(function (BlameLogRefType) {
    BlameLogRefType["Case"] = "CASE";
    BlameLogRefType["User"] = "USER";
    BlameLogRefType["Creditor"] = "CREDITOR";
    BlameLogRefType["UserOnCustomer"] = "USER-ON-CUSTOMER";
    BlameLogRefType["TenantSettings"] = "TENANT-SETTINGS";
})(BlameLogRefType || (exports.BlameLogRefType = BlameLogRefType = {}));
exports.economyTypes = [
    BlameLogType.CaseVoucherDelete,
    BlameLogType.UnknownCaseVoucherMapped,
    BlameLogType.CaseVoucherPatch,
    BlameLogType.CaseVoucherExpired,
    BlameLogType.CaseVoucherIrrecoverable,
];
exports.interactionTypes = [
    BlameLogType.InteractionDelete,
    BlameLogType.InteractionHideFromClient,
    BlameLogType.InteractionRollback,
];
exports.visitTypes = [
    BlameLogType.CaseVisit,
    BlameLogType.UserOnCustomerVisit,
    BlameLogType.CreditorVisit,
];
exports.debtorUpdateTypes = [
    BlameLogType.DebtorUpdateName,
    BlameLogType.DebtorUpdatePhone,
    BlameLogType.DebtorUpdateAddress,
    BlameLogType.DebtorUpdateEmail,
    BlameLogType.DebtorUpdateCourt,
    BlameLogType.DebtorUpdateCarRegistrationNumber,
    BlameLogType.DebtorUpdateBirthdate,
    BlameLogType.DebtorUpdateCVR,
    BlameLogType.DebtorUpdateCPR,
];
exports.workflowTypes = [
    BlameLogType.WorkflowRollback,
    BlameLogType.DeleteUpdate,
];
exports.settingTypes = [
    BlameLogType.RKIAuto,
    BlameLogType.RKIOpen,
    BlameLogType.RKIIgnoreOppositions,
    BlameLogType.RKIDeleteOnCaseEnd,
    BlameLogType.AKSConfiguration,
    BlameLogType.AKSClientID,
    BlameLogType.RKIOveride,
    BlameLogType.AKSActivated,
    BlameLogType.PriceList,
    BlameLogType.UserPasswordUpdate,
    BlameLogType.TriggerShortcut,
    BlameLogType.WorkflowChange,
    BlameLogType.ConnectorBillingUpdate,
    BlameLogType.CreditorSettingsUpdate,
];
//# sourceMappingURL=index.js.map